/**
 * Does template interpolation
 *
 * @param template
 * @param variables
 * @returns {void | * | string}
 */
export function bindVar (template, variables) {
  return template.replace(/{([^{]+)}/g, (_unused, varName) => {
    return variables[varName]
  })
}

/**
 * Changes object into a query string
 *
 * @param obj
 * @returns {string}
 */
export function objQueryString (obj) {
  return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&')
}

export function isEU (code) {
  var euList = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'EL',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK'
  ]

  return euList.indexOf(code) !== -1
}
